<app-header [ngClass]="{'app-header': !home}"></app-header>
<div class="app-main">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
